import Gamma from '@gonfalon/img/customer-logos/gamma.svg';
import Gitlab from '@gonfalon/img/customer-logos/gitlab.svg';
import Hashi from '@gonfalon/img/customer-logos/hashi.svg';
import Hex from '@gonfalon/img/customer-logos/hex.svg';
import Hulu from '@gonfalon/img/customer-logos/hulu.svg';
import Priceline from '@gonfalon/img/customer-logos/priceline.svg';
import Qlik from '@gonfalon/img/customer-logos/qlik.svg';
import Ramp from '@gonfalon/img/customer-logos/ramp.svg';
import Rivian from '@gonfalon/img/customer-logos/rivian.svg';
import Vercel from '@gonfalon/img/customer-logos/vercel.svg';
import cx from 'clsx';

import styles from './SignUpHeroCompanyLogos.module.css';

export const SignUpHeroCompanyLogos = ({ variant = 'light' }: { variant?: 'light' | 'dark' }) => {
  const logoClass = variant === 'dark' ? styles.darkLogo : styles.whiteLogo;
  const SecondLogo = variant === 'dark' ? Ramp : Vercel;

  return (
    <div className={styles.logos}>
      <span className={cx(logoClass, styles.logoSmall)}>
        <Hulu />
      </span>
      <span className={cx(logoClass, styles.logoLarge)}>
        <SecondLogo />
      </span>
      <span className={cx(variant === 'dark' ? logoClass : undefined, styles.logoXLarge)}>
        <Gitlab />
      </span>
      <span className={cx(logoClass, styles.logoSmall)}>
        <Gamma />
      </span>
      <span className={cx(logoClass, styles.logoLarge)}>
        <Hex />
      </span>
      <span className={cx(logoClass, styles.logoLarge)}>
        <Priceline />
      </span>
      <span className={cx(logoClass, styles.logoXLarge)}>
        <Qlik />
      </span>
      <span className={cx(logoClass, styles.logoSmall)}>
        <Rivian />
      </span>
      <span className={cx(logoClass, styles.logoXLarge)}>
        <Hashi />
      </span>
    </div>
  );
};
